/* eslint-disable no-unused-vars */
import moment from 'moment';

import helpers from '../../helpers';
import { groupLessonBook, individualLessonBook } from './api';

/* */
export const getRegistrationStatus = (event, golfOptions) => {
  const { daysInAdvance } = {
    ...golfOptions.academy.onlineRestrictions.global,
    ...golfOptions.academy.onlineRestrictions.group,
  };

  let status = 1;
  let statusText;

  const startAt = moment(event.startsAt, 'YYYY-MM-DDTHH:mm');

  if (moment(startAt).isBefore()) {
    status = 0;
    statusText = 'Inscriptions closes';
  } else if (moment(startAt).subtract(daysInAdvance, 'days').isAfter()) {
    status = 1;
    if (moment(startAt).subtract(daysInAdvance, 'days').isAfter(moment(startAt))) {
      status = 0;
      statusText = 'Pas d\'inscription en ligne';
    } else {
      statusText = `Début des inscriptions le ${moment(startAt).subtract(daysInAdvance, 'days').format('DD/MM/YYYY')}`;
    }
  } else if (moment(startAt).subtract(daysInAdvance, 'days').isBefore()) {
    status = 2;
    if (startAt.dayOfYear() === moment().dayOfYear()) {
      statusText = 'Dernier jour d\'inscription';
    } else {
      statusText = `Inscriptions ouvertes jusqu'au ${moment(startAt).format('DD/MM/YYYY')}`;
    }
    if (!event.openOnline) {
      status = 3;
      statusText += ' (uniquement à l\'accueil)';
    }
  } else {
    status = 0;
    statusText = 'Inscriptions closes';
  }

  return { status, statusText };
};
/* */
export const isOpened = (event, options) => {
  const { status } = getRegistrationStatus(event, options);
  return status === 2;
};

export const asyncSetEntry = (client, { enter, golf, transaction }) => {
  const { lesson, entrants, comment = null } = enter;

  const date = lesson && lesson.startsAt;
  switch (lesson.type) {
    case 'INDIVIDUAL':
      return individualLessonBook(client, {
        input: {
          source: 'WEB',
          coachSlot: {
            coachId: lesson.headCoach.id,
            date: moment(date).format('YYYY-MM-DD'),
            startTime: moment(lesson.startsAt).format('HH:mm:ss'),
            endTime: moment(lesson.endsAt).format('HH:mm:ss'),
          },
          customers: entrants.map((e) => ({
            id: e.id,
            lastName: e.lastname,
            firstName: e.firstname,
            phone: e.phone,
            email: e.email,
            gender: e.gender,
            dateOfBirth: e.dateOfBirth,
          })),
        },
      });
    case 'GROUP':
      return groupLessonBook(client, {
        input: {
          source: 'WEB',
          lessonId: lesson.id,
          customers: entrants.map((e) => ({
            id: e.id,
            lastName: e.lastname,
            firstName: e.firstname,
            phone: e.phone,
            email: e.email,
            gender: e.gender,
            dateOfBirth: e.dateOfBirth,
          })),
          status: 'CONFIRMED',
        },
      });
    default:
      throw new Error('Unknown lesson type');
  }
};

export const noop = () => {};
